import { useMemo } from 'react';

import { IVirtualTour } from '~/entities/virtualTour';

interface GroupedData {
  firstItemsOfGroups: IVirtualTour[];
  totalGroups: number;
  totalItems: number;
}

const useFirstItemsOfGroups = (items: IVirtualTour[]): GroupedData => {
  return useMemo(() => {
    const groupedItems = items.reduce((acc, item) => {
      if (!acc[item.projectId]) {
        acc[item.projectId] = item; // Store only the first item for each group
      }
      return acc;
    }, {} as { [projectId: string]: IVirtualTour });

    const firstItemsOfGroups = Object.values(groupedItems);
    const totalGroups = firstItemsOfGroups.length;
    const totalItems = items.length;

    return { firstItemsOfGroups, totalGroups, totalItems };
  }, [items]);
};

export default useFirstItemsOfGroups;
